import { useContext } from 'react';
import { useStrategy } from '../../hooks/useStrategy';
import { useViewerActions } from '../../hooks/useViewerActions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import UIButton from 'UIComponents/button/UIButton';
import { TestIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerTestFiltersButton = () => {
  const {
    isInTestFilters,
    props: {
      baseFilterFamily
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getFilterFamilyObjectName
  } = useStrategy();
  const {
    onShowTestFilters,
    onHideTestFilters
  } = useViewerActions();
  if (!isInTestFilters) {
    const objectType = getFilterFamilyObjectName(baseFilterFamily);
    const lowercaseObjectType = objectType.toLocaleLowerCase();
    return /*#__PURE__*/_jsx(UIButton, {
      size: "xs",
      use: "tertiary-light",
      onClick: onShowTestFilters,
      responsive: false,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "100",
        children: [/*#__PURE__*/_jsx(TestIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.testFilters.showTestFilters",
          options: {
            lowercaseObjectType,
            objectType
          }
        })]
      })
    });
  }
  return /*#__PURE__*/_jsxs(UIButton, {
    size: "xs",
    use: "tertiary-light",
    onClick: onHideTestFilters,
    responsive: false,
    children: [/*#__PURE__*/_jsx(TestIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.testFilters.hideTestFilters"
    })]
  });
};
export default ViewerTestFiltersButton;